import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpService } from '../http/http.service';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class EnduserService {
    public Enduserdata: any;

    constructor(private httpService: HttpService) { }

    // saveEnduser(data: any): Observable<any> {
    //   const url = `${environment.baseUrl}/api/order`;
    //   return this.httpService
    //     .post(url, data, this.httpService.headers)
    //     .pipe(catchError(this.Errorhandling));

    // }


    onSaveRating(data: any): Observable<any> {
        const url = `${environment.EnduserApiendpoints}/addFeedback`
        return this.httpService.post(url, data, this.httpService.headers)
    }

    onSaveenduser(data: any): Observable<any> {
        const url = `${environment.EnduserApiendpoints}/addEnduser`
        return this.httpService.post(url, data, this.httpService.headers)
    }
    onSaveendUserWeb(data: any): Observable<any> {
        const url = `${environment.EnduserApiendpoints}/addEnduserWeb`
        return this.httpService.post(url, data, this.httpService.headers)
    }


    onSaveRoster(data: any,enduser_id:any): Observable<any> {
        const url = `${environment.EnduserApiendpoint }/roster/${enduser_id}`
        return this.httpService.post(url, data, this.httpService.headers)
    }
    addPatientReport(data: any) {
        const url = `${environment.TestReportApiendpoint}/report/testReport`;
        return this.httpService.post(url,data, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    getEnduserByclientId(id: any) {
        const url = `${environment.EnduserApiendpoint}/enduserListByClient/${id}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

// ------for support ticket-//
    getallEndusersList(phone) {
        const url = `${environment.EnduserApiendpoint}/all-enduser?phone=${phone}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    // addEnduser(data: any): Observable<any> {
    //     const url = `${environment.EnduserApiendpoint }/create-enduser`
    //     return this.httpService.post(url, data, this.httpService.headers)
    // }


    deleteEnduser(id: any) {
        const url = `${environment.EnduserApiendpoints}/deleteEnduser/${id}`;
        return this.httpService.delete(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    deletePrescription(id: any) {
        const url = `${environment.EnduserApiendpoints}/deletePrescription/${id}`;
        return this.httpService.delete(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    obtainEnduser(user: any) {
        const url = `${environment.EnduserApiendpoints}/enduserlistbyId/${user}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    updateEnduser(data: any, Enduser: any): Observable<any> {
        const url = `${environment.EnduserApiendpoints}/updateEnduser/${Enduser}`
        return this.httpService.put(url, data, this.httpService.headers)
    }

    updateStatus(id: any, status: any): Observable<any> {



        let data ;
        if (status == 'Active') {
            data = {
                status: 'Inactive'
            };
        }else{
            data = {
                status: 'Active'
            };
        }
        const url = `${environment.EnduserApiendpoint}/Enduser-change-status/${id}`;
        return this.httpService.patch(url, data, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    obtainEndusers(search: any) {
        const url = `${environment.EnduserApiendpoint}/endusers?${search}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }



    // prescription status Change
    changeStatus(data: any,id:any): Observable<any> {
      const url = `${environment.EnduserApiendpoints}/changeStatus/${id}`;
      return this.httpService.put(url, data, this.httpService.headers);
    }

    getEnduser(data: any): Observable<any> {
        this.Enduserdata = [
            {
                id: '1',
                emp_code: '123',
                first_name: 'Abhishek',
                last_name: 'Anand',
                email: 'temp@email.com',
                phone: '25012021',
                status: 'Active',
                city: 'Dehradun',
                state: 'Uttarakhand',
            },
        ];

        return this.Enduserdata;
    }
    Errorhandling(err: HttpErrorResponse) {
        if (err.error instanceof ErrorEvent) {
            console.error(err.error.message);
        } else {
            console.error(`Backend returned code ${err.status}`);
        }
        return throwError('Please try again later.');
    }
}
